import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { actionsHandlers, stateFactories } from 'store/entities/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const subscriptionPricesReducer = createReducer<State, Actions>(initialState, {
  [actions.getSubscriptionPrices.request.type]: actionsHandlers.handleGetManyRequest,
  [actions.getSubscriptionPrices.success.type]: actionsHandlers.handleGetManySuccess,
  [actions.getSubscriptionPrices.failure.type]: actionsHandlers.handleGetManyFailure,
  [actions.getSubscriptionPrices.reset.type]: actionsHandlers.handleGetManyReset,
});

export default subscriptionPricesReducer;
